import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("germac_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;

export const ROLE_LABELS = {
  admin: "Admin",
  magazziniere: "Magazziniere",
  meccanico: "Meccanico",
  ufficio_acquisti: "Ufficio Acquisti",
};

export const CATEGORIE = [
  "Filtro", "Punta", "Kit Guarnizioni", "Guarnizione", "Cuscinetto",
  "Cinghia", "Tubo Idraulico", "Olio", "Pistone", "Valvola",
  "Bullone", "Vite", "Catena", "Elettrico", "Altro",
];

export const CAUSALI_SCARICO = [
  "Officina interna", "Cliente", "Resi a fornitore", "Manutenzione macchina",
  "Sostituzione in cantiere", "Scarto", "Altro",
];

export function formatApiError(detail) {
  if (detail == null) return "";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map(e => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

/**
 * Estrae un messaggio d'errore leggibile da un errore Axios.
 * Include lo status HTTP se non c'è un detail testuale.
 */
export function extractApiError(err, fallback = "Errore imprevisto") {
  if (!err) return fallback;
  const resp = err.response;
  const msg = formatApiError(resp?.data?.detail);
  if (msg) return msg;
  if (resp?.status) {
    if (resp.status === 401) return "Sessione scaduta. Rifai il login.";
    if (resp.status === 403) return "Non hai i permessi per questa operazione.";
    if (resp.status === 404) return "Risorsa non trovata.";
    if (resp.status === 413) return "File troppo grande.";
    if (resp.status === 422) return "Dati non validi. Controlla i campi obbligatori.";
    if (resp.status >= 500) return `Errore server (${resp.status}). Riprova o contatta l'assistenza.`;
    return `Errore ${resp.status}`;
  }
  if (err.code === "ERR_NETWORK") return "Nessuna connessione al server. Controlla la rete.";
  if (err.message) return err.message;
  return fallback;
}
